import type { Language } from "../i18n";
import { t } from "../i18n";

export interface LowLightPromptProps {
  visible: boolean;
  onEnableTorch: () => void | Promise<void>;
  language?: Language;
}

/**
 * Floating prompt banner shown when persistent low light is detected
 * and the device camera supports torch capability.
 */
export function LowLightPrompt({
  visible,
  onEnableTorch,
  language = "ru",
}: LowLightPromptProps) {
  if (!visible) return null;

  const text = t(language, "low_light_text");

  return (
    <button
      type="button"
      className="low-light-prompt"
      onClick={onEnableTorch}
      data-testid="low-light-prompt"
      aria-label={text}
    >
      <span className="low-light-prompt__icon" aria-hidden="true">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
        </svg>
      </span>
      <span className="low-light-prompt__text">{text}</span>
    </button>
  );
}
